<int-labeled-field-box
  [isFocus]="isFocused"
  [isError]="isError"
  [isActive]="isFocused || isFill"
  [direction]="dir$ | async"
  [label]="currentLabel"
  [showLabelTip]="showLabelTip"
  [hideField]="hideField"
  [verticalAlign]="verticalAlign"
>
  <ng-container ngProjectAs="center-position">
    <input
      [class.f-error]="isError"
      [class.hide-placeholder]="hidePlaceholder"
      int-default-input-field
      *ngIf="!hideDefaultField"
      aria-label="default"
      [type]="type"
      [placeholder]="placeholder"
      [readonly]="readonly"
      [disabled]="disabled"
      [autocomplete]="autocomplete"
      [name]="name"
    >
  </ng-container>
  <ng-container ngProjectAs="left-position">
    <ng-content select="left-position"></ng-content>
  </ng-container>
  <ng-container ngProjectAs="right-position">
    <ng-content select="right-position"></ng-content>
  </ng-container>
</int-labeled-field-box>

